<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import formInput from "@/mixins/shared/formInput";
import MultipleChecks from "@/mixins/shared/multipleChecks";
import MultipleChecksProps from "@/mixins/shared/multipleChecksProps";

export default {
	mixins: [formInput, MultipleChecks, MultipleChecksProps],
	components: {Radio},
}
</script>

<template>
	<div class="d-flex flex-wrap gap-2" :class="{'flex-column' : layout === 'vertical'}">
		<Radio
			v-bind="$attrs"
			v-for="(option, index) in renderedOptions"
			:key="index"
			@update:modelValue="$emit('update:modelValue', $event)"
			:model-value="modelValue"
			:form="form"
			:name="name"
			:id="`${this.renderedId}-${index}`"
			:value="optionValue(option)"
			:label="optionLabel(option)"
		/>
	</div>
	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom" />
	</div>
	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>